import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _findAllFqaDictData(fqaDictId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data/all`,
    method: 'get',
    params: {
      fqaDictId,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryFqaDictData(
  fqaDictId,
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryFqaDictDataById(fqaDictId, fqaDictDataId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data/${fqaDictDataId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  code
 * @param  name
 * @param  detail
 * @param  fqaDictId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addFqaDictData(
  fqaDictId,
  {
    code,
    name,
    detail,
    detailEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data`,
    method: 'post',
    data: {
      fqaDictId,
      code,
      name,
      detail,
      detailEn,
    },
  });
}

/**
 * 更新
 * @param fqaDictDataId
 * @param  code
 * @param  name
 * @param  detail
 * @param  fqaDictId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateFqaDictData(
  fqaDictId,
  fqaDictDataId, {
    code,
    name,
    detail,
    detailEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data/${fqaDictDataId}`,
    method: 'patch',
    data: {
      code,
      name,
      detail,
      detailEn,
      fqaDictId,
    },
  });
}

/**
 * 删除
 * @param fqaDictId
 * @param fqaDictDataId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteFqaDictData(fqaDictId, fqaDictDataId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data/${fqaDictDataId}`,
    method: 'delete',
  });
}

/**
 * 上移
 * @param fqaDictId
 * @param fqaDictDataId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upFqaDictData(fqaDictId, fqaDictDataId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data/up/${fqaDictDataId}`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param fqaDictId
 * @param fqaDictDataId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downFqaDictData(fqaDictId, fqaDictDataId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dict/${fqaDictId}/data/down/${fqaDictDataId}`,
    method: 'patch',
  });
}

export default {};
